import alertToast from 'Util/ToastifyUtils';

export const handleForbiddenRequest = () => {
	alertToast('You do not have permission to perform this action.', 'error');
};
